<script setup>
import TaskHeader from './TasksHeader/TaskHeader.vue';
import PaginationFooter from 'dashboard/components-next/pagination/PaginationFooter.vue';

defineProps({
  headerTitle: { type: String, default: '' },
  openCount: { type: Number, default: 0 },
  overdueCount: { type: Number, default: 0 },
  currentPage: { type: Number, default: 1 },
  totalItems: { type: Number, default: 0 },
  activeSort: { type: String, default: 'due_at' },
  activeOrdering: { type: String, default: '' },
  viewMode: { type: String, default: 'list' },
  filters: { type: Object, default: () => ({}) },
  showPaginationFooter: { type: Boolean, default: true },
});

const emit = defineEmits([
  'update:currentPage',
  'update:sort',
  'update:viewMode',
  'apply-filters',
  'clear-filters',
  'create-task',
]);

const updateCurrentPage = page => {
  emit('update:currentPage', page);
};
</script>

<template>
  <section class="flex w-full h-full p-3 overflow-hidden bg-n-background">
    <div
      class="flex flex-col w-full h-full rounded-2xl border border-n-container bg-n-solid-2 overflow-hidden"
    >
      <TaskHeader
        :header-title="headerTitle"
        :open-count="openCount"
        :overdue-count="overdueCount"
        :active-sort="activeSort"
        :active-ordering="activeOrdering"
        :view-mode="viewMode"
        :filters="filters"
        @update:sort="emit('update:sort', $event)"
        @update:view-mode="emit('update:viewMode', $event)"
        @apply-filters="emit('apply-filters', $event)"
        @clear-filters="emit('clear-filters')"
        @create-task="emit('create-task')"
      />
      <main class="flex-1 overflow-y-auto min-h-0">
        <div class="w-full" :class="{ 'h-full': viewMode === 'kanban' }">
          <slot name="default" />
        </div>
      </main>
      <footer
        v-if="showPaginationFooter && viewMode === 'list'"
        class="sticky bottom-0 z-0 px-4 pb-4 border-t border-n-weak bg-n-solid-2"
      >
        <PaginationFooter
          current-page-info="TASKS_DASHBOARD_LAYOUT.PAGINATION_FOOTER.SHOWING"
          :current-page="currentPage"
          :total-items="totalItems"
          :items-per-page="25"
          @update:current-page="updateCurrentPage"
        />
      </footer>
    </div>
  </section>
</template>
